import React from 'react';
import { FDAlert } from '@facet-wealth/design';

export function HeroAlert({
  value,
}) {
  if (!value) {
    return null;
  }

  return (
    <FDAlert
      status={'info'}
      title={value}
    />
  );
}
